<template>
    <div
        class="kgr-inputGroup"
        :class="{ 'with-errors': error.forField('file') }"
    >
        <div class="kgr-inputGroup__label ui-droppable">
            {{ $t('field.image') }}
        </div>

        <div class="kgr-postfix kgr-postfix--gutters kgr-postfix--top kgr-row kgr-row--smallMargin">
            <div
                v-if="!loading"
                class="kgr-postfix__fixed"
            >
                <img
                    :src="imageUrl"
                    :alt="field.name"
                />
            </div>
            <div class="kgr-postfix__fluid">
                <kgr-file-chooser @change="onImageChange" />
                <template v-if="imageFile">
                    <hr class="kgr-separator kgr-separator--light" />
                    <kgr-button
                        :value="$t('field.image.upload')"
                        :pending="pendingUpload"
                        type="blue"
                        @click="uploadImage"
                    />
                </template>
                <template v-if="!loading && field.hasImage && !imageFile">
                    <hr class="kgr-separator kgr-separator--light" />
                    <kgr-button
                        :value=" $t('field.image.delete')"
                        :pending="pendingUpload"
                        class="kgr-button kgr-button--small kgr-button--danger"
                        @click="deleteImage()"
                    />
                </template>
            </div>
        </div>

        <div
            v-if="error.forField('file')"
            class="kgr-inputGroup__text kgr-inputGroup__text--error"
        >
            {{ error.messageForField('file') }}
        </div>
        <div class="kgr-inputGroup__text">
            {{ $t('field.image.note') }}
        </div>
    </div>
</template>

<script>
import Error from '../../js/model/Error';
import FieldRepository from '../../js/repository/FieldRepository';
import FileChooser from '../../components/common/file/FileChooser';
import KgrButton from '../../components/common/form/button/KgrButton';

export default {
    components: {
        'kgr-file-chooser': FileChooser,
        'kgr-button': KgrButton,
    },
    props: {
        locationId: {
            type: String,
            required: true,
        },
        areaId: {
            type: String,
            required: true,
        },
        fieldId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            imageFile: null,
            error: new Error(),
            pendingUpload: false,
            loading: true,
            cacheBreaker: Date.now(),
            field: null,
        }
    },
    computed: {
        imageUrl() {
            return this.field.imageUrl + '?v=' + this.cacheBreaker;
        }
    },
    created() {
        FieldRepository.find(this.locationId, this.areaId, this.fieldId)
            .then(field => {
                this.error = new Error();
                this.field = field;
            })
            .catch(error => this.handleError(error))
            .finally(() => this.loading = false)
    },
    methods: {
        deleteImage() {
            showConfirm(this.$t('confirm'), this.$t('field.image.delete.confirm'), () => {
                FieldRepository.removeImage(this.locationId, this.areaId, this.fieldId)
                    .then(() => {
                        this.error = new Error();
                        this.cacheBreaker = Date.now();
                        this.field.hasImage = false;

                        this.$forceUpdate();
                        this.$notify.success('field.image.delete.success');
                    })
                    .catch(error => this.handleError(error));

                this.imageFile = null;
            }, 'Ok');
        },
        onImageChange(imageFile) {
            this.imageFile = imageFile;
        },
        uploadImage() {
            if (this.imageFile) {
                this.pendingUpload = true;
                FieldRepository.uploadImage(this.locationId, this.areaId, this.fieldId, this.imageFile)
                    .then(() => {
                        this.error = new Error();
                        this.cacheBreaker = Date.now();
                        this.field.hasImage = true;
                        this.imageFile = null;

                        this.$forceUpdate();
                        this.$notify.success('field.image.upload.success');
                    })
                    .catch(error => this.handleError(error))
                    .finally(() => this.pendingUpload = false)
            }
        },
        handleError(error) {
            this.error = error;
            this.$notify.error('saveChanges.error');
        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
